import { generateIconComponent } from './icons.utils';

export const SearchSolidIcon = generateIconComponent({
    name: 'SearchSolidIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M2.96145 8.88436C2.96145 5.61788 5.61788 2.96145 8.88436 2.96145C12.1508 2.96145 14.8073 5.61788 14.8073 8.88436C14.8073 12.1508 12.1508 14.8073 8.88436 14.8073C5.61788 14.8073 2.96145 12.1508 2.96145 8.88436ZM23.7834 21.6867L16.1192 14.024C17.1527 12.5714 17.7687 10.7989 17.7687 8.88436C17.7687 3.98464 13.7841 0 8.88436 0C3.98464 0 0 3.98464 0 8.88436C0 13.7841 3.98464 17.7687 8.88436 17.7687C10.8004 17.7687 12.5714 17.1527 14.0255 16.1177L21.6882 23.782C21.9784 24.0707 22.4463 24.0707 22.7351 23.782L23.7834 22.7351C24.0722 22.4449 24.0722 21.977 23.7834 21.6867Z" />
    ),
});
